<template>
    <div class="main-content">
        <!-- HEADER -->
        <div class="header">
            <div class="container-fluid">
                <div :class="`card mt-5`">
                    <div class="card-body">
                        <div class="row justify-content-between align-items-center">
                            <div class="col-12 col-md-9 col-xl-7">
                                <!-- Heading -->
                                <h2 class="mb-2">Budget Historical</h2>
                                {{ year }}
                                <!-- <month-picker @change="showDate"></month-picker> -->

                            </div>
                        </div>
                    </div>
                </div>

                <div :class="`card mt-5`">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label>Year</label>
                                    <date-picker type="year" v-model="filter.year" style="width: 100%;"
                                        value-type="format" format="YYYY" placeholder="Select year" :clearable="false">
                                    </date-picker>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label>Month</label>
                                    <v-select :options="monthData" label="label" :reduce="((e) => e.value)"
                                        v-model="filter.month" :clearable="!filter.week"></v-select>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label>Week</label>
                                    <v-select :options="weekData" label="label" :reduce="((e) => e.value)"
                                        v-model="filter.week" :disabled="!filter.month"></v-select>
                                </div>
                            </div>
                            <div class=" d-flex justify-content-end">
                                <b-button v-if="isLoading == false" variant="primary" @click="getAllHistory()">Search
                                </b-button>
                                <button type="button" class="btn btn-primary" disabled v-else>
                                    <span class="spinner-border spinner-border-sm" role="status"
                                        aria-hidden="true"></span>
                                    Loading...
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Body -->
                <div class="row">
                    <div class="card">
                        <div class="card-body">
                            <b-tabs content-class="mt-0" pills fill card>
                                <b-tab title="General Budget" active>
                                    <div class="row align-items-center mt-0">
                                        <div class="col-lg-4">
                                            <div class="col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL PLAN OPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.budget_plan.opex) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL ACTUAL OPEX (incl. Relocate Out)
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.actual_budget.opex) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL REMAINING OPEX (incl. Relocate In)
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.remaining_budget.opex) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL PLAN CAPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.budget_plan.capex) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL ACTUAL CAPEX (incl. Relocate Out)
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.actual_budget.capex) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL REMAINING CAPEX (incl. Relocate In)
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.remaining_budget.capex) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL PLAN
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.budget_plan.total) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL ACTUAL (incl. Relocate Out)
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.actual_budget.total) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL REMAINING (incl. Relocate In)
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.remaining_budget.total) }}
                                                </span>
                                            </div>
                                        </div>


                                    </div> <!-- / .row -->
                                </b-tab>
                                <b-tab title="Budget Relocation">
                                    <div class="row align-items-center mt-0 gx-0">
                                        <div class="col-lg-4">
                                            <div class="col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE IN OPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.relocate_in.opex) }}
                                                </span>
                                            </div>

                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE OUT OPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.relocate_out.opex) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE IN CAPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.relocate_in.capex) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE OUT CAPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.relocate_out.capex) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE IN
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.relocate_in.total) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE OUT
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp. {{ convertNumber(historyData.summary.relocate_out.total) }}
                                                </span>
                                            </div>
                                        </div>


                                    </div> <!-- / .row -->
                                </b-tab>
                                <b-tab title="Internal Relocation Budget">
                                    <div class="row align-items-center mt-0 gx-0">
                                        <div class="col-lg-4">
                                            <div class="col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE INTERNAL IN OPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp.
                                                    {{ convertNumber(historyData.summary.relocate_int_int_to.opex) }}
                                                </span>
                                            </div>

                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE INTERNAL OUT OPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp.
                                                    {{ convertNumber(historyData.summary.relocate_int_int_from.opex) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE INTERNAL IN CAPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp.
                                                    {{ convertNumber(historyData.summary.relocate_int_int_to.capex) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE INTERNAL OUT CAPEX
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp.
                                                    {{ convertNumber(historyData.summary.relocate_int_int_from.capex) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE INTERNAL IN
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp.
                                                    {{ convertNumber(historyData.summary.relocate_int_int_to.total) }}
                                                </span>
                                            </div>
                                            <div class="mt-5 col-lg-12">

                                                <!-- Title -->
                                                <h6 class="text-uppercase text-body-secondary mb-2">
                                                    TOTAL RELOCATE INTERNAL OUT
                                                </h6>

                                                <!-- Heading -->
                                                <span class="h2 mb-0">
                                                    Rp.
                                                    {{ convertNumber(historyData.summary.relocate_int_int_from.total) }}
                                                </span>
                                            </div>
                                        </div>


                                    </div> <!-- / .row -->
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- / .header -->
    </div>
    <!-- / .main-content -->
</template>
<script>
    // import Chart from 'chart.js'
    import lang from "@/lang.json";
    import axiosIns from "@/api/axios";
    import moment, {
        months
    } from "moment";
    import {
        MonthPickerInput
    } from 'vue-month-picker'

    export default {
        name: "HomeView",
        computed: {
            historyData() {
                return this.$store.getters["history/dataHistory"];
            },
        },
        components: {
            MonthPickerInput
        },
        data() {
            return {
                filter: {
                    year: '',
                    month: null,
                    week: null
                },
                monthData: [{
                        label: 'January',
                        value: 1
                    },
                    {
                        label: 'February',
                        value: 2
                    },
                    {
                        label: 'March',
                        value: 3
                    },
                    {
                        label: 'April',
                        value: 4
                    },
                    {
                        label: 'May',
                        value: 5
                    },
                    {
                        label: 'June',
                        value: 6
                    },
                    {
                        label: 'July',
                        value: 7
                    },
                    {
                        label: 'August',
                        value: 8
                    },
                    {
                        label: 'September',
                        value: 9
                    },
                    {
                        label: 'October',
                        value: 10
                    },
                    {
                        label: 'November',
                        value: 11
                    },
                    {
                        label: 'December',
                        value: 12
                    }
                ],
                weekData: [{
                        label: 'Week 1',
                        value: 1
                    },
                    {
                        label: 'Week 2',
                        value: 2
                    },
                    {
                        label: 'Week 3',
                        value: 3
                    },
                    {
                        label: 'Week 4',
                        value: 4
                    }
                ],
                isLoading: false
            }
        },
        mounted() {
            this.filter.year = String(new Date().getFullYear())
            this.getAllHistory()
        },
        methods: {
            getAllHistory() {
                this.isLoading = true
                let datas = this.filter
                Object.keys(datas).forEach(key => {
                    if (datas[key] === null) {
                        delete datas[key];
                    }
                });

                this.$store.dispatch('history/GET_HISTORY', datas).then(() => {
                    this.isLoading = false
                })
            },

            convertNumber(dat) {
                return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            },

            formatter(date) {
                // Use JavaScript's Intl API to format only the month
                return date ? new Intl.DateTimeFormat('en', {
                    month: 'long'
                }).format(date) : ''
            }
        }
    };
</script>
<style>


</style>